import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Footer.css';

function Footer() {
  return (
    <footer className="rjc-footer py-4">
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={6}>
            <p>&copy; {new Date().getFullYear()} Russell Blanchard Creations. All rights reserved.</p>
            <p>Crafted with passion by R.B.C.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;